import React, { useState } from "react";
import "../App.css";
import Nav from "./Navigation.js";

const Grid = () => {
  const colorsArray = [
    { color: "bg-blue-500", label: "1" },
    { color: "bg-red-500", label: "2" },
    { color: "bg-green-500", label: "3" },
    { color: "bg-yellow-500", label: "4" },
    { color: "bg-purple-500", label: "5" },
    { color: "bg-pink-500", label: "6" },
    { color: "bg-indigo-500", label: "7" },
    { color: "bg-orange-500", label: "8" },
  ];

  const [colors, setColors] = useState(Array(16).fill(""));
  const [currentColor, setCurrentColor] = useState(null);
  const [selectedColorIndex, setSelectedColorIndex] = useState(null);

  const handleClick = (index, event) => {
    event.preventDefault();
    const newColors = [...colors];
    if (event.button === 2 || event.ctrlKey || event.metaKey) {
      // Right-click to reset the box
      newColors[index] = "";
    } else {
      // Assign the selected color to the box
      newColors[index] = currentColor;
    }
    setColors(newColors);
  };

  const handleColorSelect = (color, index) => {
    // Update the current color selected from the palette
    setCurrentColor(color);
    setSelectedColorIndex(index);
  };

  const handleReset = () => {
    // Reset the entire grid
    setColors(Array(16).fill(""));
    setCurrentColor(null);
    setSelectedColorIndex(null);
  };

  return (
    <div>
      <Nav />
      <div className="container mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-white text-center">Matching Memory Assistance Tool</h1>
        <div className="text-white text-center">
          Directions: This is a simple tool to help with the matching memory
          game. Simply select the color from the palette and mark the matching
          locations
        </div>
        <div className="text-white text-center">
          You can right click any box if you marked them by mistake or wish to
          remove your color selection or select a different color to override
          the current color
        </div>
        <div className="flex justify-center">
          <div className="grid grid-cols-4 gap-1"> {/* Adjust the gap value here */}
            {[...Array(4).keys()].map((rowIndex) =>
              [...Array(4).keys()].map((colIndex) => {
                const index = rowIndex * 4 + colIndex;
                return (
                  <div
                    key={index}
                    className={`relative h-16 w-16 cursor-pointer border border-gray-400 ${colors[index]}`}
                    onClick={(event) => handleClick(index, event)}
                    onContextMenu={(event) => handleClick(index, event)}
                  >
                    {colors[index] && (
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-3xl font-bold">
                        {colorsArray.findIndex((c) => c.color === colors[index]) + 1}
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>

        <div className="flex justify-center mt-4 space-x-4">
          {colorsArray.map((color, index) => (
            <div
              key={index}
              className={`flex items-center justify-center h-12 w-12 cursor-pointer border border-white-800 ${
                color.color
              } ${selectedColorIndex === index ? "border-4" : ""}`}
              onClick={() => handleColorSelect(color.color, index)}
            >
              {color.label}
            </div>
          ))}
        </div>
        <button
          className="mt-4 bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded"
          onClick={handleReset}
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default Grid;
